<template>
    <div class="form-item">
        <label class="label-caption">Tipo Agendamento</label>
        <select :value="tipoSelecionado" @change="atualizarTipo" class="form-control" v-bind="$attrs">
            <option v-for="tipo in lsTipos" :key="tipo.id" :value="tipo.id">{{ tipo.descricao }}</option>
        </select>
    </div>
</template>
  
<script>
export default {
    props: {
        tipoSelecionado: {type: Number, default: null}
    },

    data() {
        return{
            lsTipos:[
                {id: 1, descricao: 'ORDEM DE OS'},
                {id: 2, descricao: 'AGENDAMENTO'}
            ]
        };
    },

    methods: {
        atualizarTipo(event) {
            this.$emit('update:tipoSelecionado', Number(event.target.value));
        }
    }
};
</script>